import VueEasyLightbox from "vue-easy-lightbox";

export default {
  name: "NewsGallery",
  components: {
    VueEasyLightbox
  },
  props: {
    newsGalleryLinks: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      visible: false,
      index: 0 // default
    };
  },
  methods: {
    showSingle() {
      this.show();
    },

    showMultiple(index) {
      this.index = index; // index of imgList
      this.show();
    },

    show() {
      this.visible = true;
    },

    handleHide() {
      this.visible = false;
    }
  },
  created() {
    console.log(this.newsGalleryLinks);
  }
};
